export const MAIN_API_URL = 'https://urd5webvo9.execute-api.us-east-1.amazonaws.com/default';

export const API_URL = 'https://urd5webvo9.execute-api.us-east-1.amazonaws.com/default/ACMAComplaintPortal';
export const ADD_COMPLAINT = API_URL.concat('/add');
export const GET_BLOGS_API = MAIN_API_URL.concat('/blogs');
export const GET_COMPLAINTS = MAIN_API_URL.concat('/getcomplaints');
